import {
  getValueWithoutQuotes
} from "../chunk-EWQG4YWO.js";

// src/migration/migrateSituation.ts
function migrateSituation(situation, instructions) {
  const newSituation = { ...situation };
  const currentRules = Object.keys(situation);
  const valueKeysToMigrate = Object.keys(instructions.valuesToMigrate);
  Object.entries(situation).map(([rule, value]) => {
    handleSpecialCases(rule, value, newSituation);
    if (currentRules.includes(rule)) {
      updateKey(rule, value, newSituation, instructions.keysToMigrate[rule]);
    }
    const formattedValue = getValueWithoutQuotes(value) ?? value;
    const valuesMigration = instructions.valuesToMigrate[valueKeysToMigrate.find((key) => rule.includes(key)) ?? ""] ?? {};
    const oldValuesName = Object.keys(valuesMigration);
    if (oldValuesName.includes(formattedValue)) {
      updateValue(rule, valuesMigration[formattedValue], newSituation);
    }
  });
  return newSituation;
}
function handleSpecialCases(rule, oldValue, situation) {
  if (oldValue && typeof oldValue === "string" && !isNaN(parseFloat(oldValue))) {
    situation[rule] = parseFloat(oldValue);
  }
  const oldValeur = oldValue?.valeur;
  if (oldValeur !== void 0) {
    situation[rule] = typeof oldValeur === "string" && !isNaN(parseFloat(oldValeur)) ? parseFloat(oldValeur) : oldValeur;
  }
  const oldNodeValue = oldValue?.nodeValue;
  if (oldNodeValue !== void 0) {
    situation[rule] = typeof oldNodeValue === "string" && !isNaN(parseFloat(oldNodeValue)) ? parseFloat(oldNodeValue) : oldNodeValue;
  }
}
function updateKey(rule, oldValue, situation, ruleToMigrate) {
  if (ruleToMigrate === void 0) {
    return;
  }
  delete situation[rule];
  if (ruleToMigrate !== "") {
    situation[ruleToMigrate] = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    typeof oldValue === "object" ? oldValue?.valeur : oldValue;
  }
}
function updateValue(rule, value, situation) {
  if (value === "") {
    delete situation[rule];
  } else {
    situation[rule] = typeof value === "string" && value !== "oui" && value !== "non" ? `'${value}'` : value;
  }
}
export {
  migrateSituation
};
